module.exports = __webpack_public_path__ + "static/media/Age of Gods_ Book of Oracle.b6c89bda.png";